export default import.meta.ROLLDOWN_FILE_URL_kSHvwCjLFxLpY3FM1MyAsA